/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import clsx from 'clsx';

import BaseComponent from '../BaseComponent';
import Input from './Input';
import InputContainer from '../forms/InputContainer';

interface Props {
  'data-testid'?: string;
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  expand?: boolean;
  field: ReduxFormField<string>;
  filter?: InputFilter;
  id?: string;
  maxLength?: number;
  modifierClassName?: string;
  numRows?: number;
  onBlur?(event: React.FocusEvent<HTMLElement>): void;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  onFocus?(event: React.FocusEvent<HTMLElement>): void;
  placeholder?: string;
  tabIndex?: number;
  type?: string;
}

/**
 * @deprecated
 * Please see the inputs in the ui folder of your project
 */
export default class Textarea extends BaseComponent<Props> {
  static defaultProps = {
    expand: false,
    modifierClassName: 'TextInput--default',
    numRows: 3,
    type: 'textarea',
  };

  componentDidMount() {
    this.handleScrollLock();
  }

  componentWillUnmount() {
    this.handleScrollRelease();
  }

  handleScrollLock() {
    const domNode = ReactDOM.findDOMNode((this.refs as any).input.input.current);
    if (!domNode) {
      return;
    }
    domNode.addEventListener('scroll', this.handleScroll);
  }

  handleScrollRelease() {
    const domNode = ReactDOM.findDOMNode((this.refs as any).input.input.current);
    if (!domNode) {
      return;
    }
    domNode.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event: Event) {
    event.stopImmediatePropagation();
  }

  render() {
    const { className: classNameFromProps, modifierClassName, tabIndex, onClick } = this.props;

    const className = clsx('TextInput', modifierClassName);
    const inputClassName = clsx('TextInput-input', 'Textarea', classNameFromProps);

    return (
      <InputContainer className={className} onClick={onClick}>
        <Input ref="input" classNames={inputClassName} tabIndex={tabIndex} {...this.props} />
      </InputContainer>
    );
  }
}
